<div class="kt-container-fixed">
  <app-message-card icon="abstract-11" variant="error" subHeading="Algo saiu errado!">
    <div class="text-center">
      A página solicitada não foi encontrada.
    </div>
  </app-message-card>
</div>
